import { css } from 'next-yak'

import * as effects from '../constants/effects'

export const shadowBox = css`
  box-shadow: ${effects.SHADOW_1};
`
